import { RelocationPageTable } from "@/app/Settings/Admin/RelocationPages/Components/RelocationPageTable";
import { Button } from "@/components/catalyst/button";
import { PlusIcon } from "@heroicons/react/20/solid";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { CreateRelocationPageDialog } from "@/app/Settings/Admin/RelocationPages/Components/CreateRelocationPageDialog";

export function SettingsRelocationPagesScreen() {
  const { open } = useDialog(CreateRelocationPageDialog);

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Relocation pages
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Create custom pages for marketing purposes
          </p>
        </div>
        <Button
          onClick={() => {
            open({});
          }}
        >
          <PlusIcon />
          Add page
        </Button>
      </div>
      <RelocationPageTable />
    </div>
  );
}
